/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#fff}svg[_ngcontent-%COMP%]   path.team-primary-color[_ngcontent-%COMP%]{fill:#f6a91c}"];
export { styles as styles };
